import React from "react";
import { FaHourglassHalf, FaClock, FaCheckCircle } from "react-icons/fa";


export const makeAssType_25 = ({ book, user }) => ({
    7: {
        STEP1: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title1: "Buy the Physical Product",
            description1: "Use the link below to purchase the product. Then click the 'Next Step' button.",

            icon2: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Post review with 3+ photos",
            description2: "Wait for delivery, use the product, and then post review including at least 3 real photos.",


            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: `Purchase the Physical Product directly on Amazon. A rebate of +$${book.selectedCurrentUserAssign?.book_cost_compensation || 'NO'} will be applied once you finish`,
            full_subtitle1: "Verified Purchase and Amazon review with 3+ your own photos required. Proof of purchase is not required, but the review publication date must be later than the assignment start date. Any date mismatch may lead to account suspension.",

            full_description1: (<>
                <p className="mb-1">
                    Please purchase the <b>exact Physical Product ASIN</b> listed for this assignment using your Amazon account.
                    Do <b>not</b> buy used copies or from third-party sellers. Once delivered, use the product carefully and
                    prepare your review.                 </p>
                <p className="mb-1">Your review must show the <b>Verified Purchase</b> label and include <b>at least 3 real photos of the physical product</b>.</p>
                <p> Reimbursement covers the product’s retail price <b>excluding delivery costs</b>. Use the button below to open the Amazon page and complete your purchase.</p>
            </>),

            full_title2: "Use the product and then post your Amazon review with 3+ photos of your purchased copy",
            full_subtitle2: "Your review must display the Verified Purchase label and include real photos.",
            full_description2: (<>
                <p className="mb-1">
                    After receiving the product, write a detailed and honest review. Upload at least <b>3 original photos of the physical product</b> taken with your device. The review must be authentic, accurate, and respectful. AI-generated, plagiarized, or generic reviews
                    are not accepted.
                </p>
                <p>
                    Make sure to post from the same Amazon account you used to purchase the product so the review shows the <b> Verified Purchase</b> label.
                </p>
            </>),

            full_title3: "After Posting your Review on Amazon, Turn In this Assignment",
            full_subtitle3: "We will track your review on Amazon.",

            full_description3: (
                <p>
                    After posting your review on Amazon, submit this assignment. From this point, you have reported that you posted your review and may proceed to the next one, while we will be monitoring the appearance of your review on Amazon. <br />
                    This step is mandatory and must be done immediately after posting your review on Amazon site. <br />
                    Our team will then monitor the appearance of your review on Amazon for up to 14+ days.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the Physical Product Verified Purchase + Photos assignment!
                </p>
            ),
        },
        STEP2: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title2: "Post review with 3+ photos",
            description2: "Wait for delivery, use the product, and then post review including at least 3 real photos.",

            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",
            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "Use the product and then post your Amazon review with 3+ photos of your purchased copy",
            full_subtitle2: "Your review must display the Verified Purchase label and include real photos.",
            full_description2: (<>
                <p className="mb-1">
                    After receiving the product, write a detailed and honest review. Upload at least <b>3 original photos of the physical product</b> taken with your device. The review must be authentic, accurate, and respectful. AI-generated, plagiarized, or generic reviews
                    are not accepted.
                </p>
                <p>
                    Make sure to post from the same Amazon account you used to purchase the product so the review shows the <b> Verified Purchase</b> label.
                </p>
            </>),

            full_title3: "After Posting your Review on Amazon, Turn In this Assignment",
            full_subtitle3: "We will track your review on Amazon.",

            full_description3: (
                <p>
                    After posting your review on Amazon, submit this assignment. From this point, you have reported that you posted your review and may proceed to the next one, while we will be monitoring the appearance of your review on Amazon. <br />
                    This step is mandatory and must be done immediately after posting your review on Amazon site. <br />
                    Our team will then monitor the appearance of your review on Amazon for up to 14+ days.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    After verifying your Amazon review and order proof, we will credit your <b>Virt</b> and reimburse the
                    <b>product’s retail price (excluding delivery)</b> according to the assignment terms.
                    Thank you for completing the Physical Product Verified Purchase + Photos assignment!
                </p>
            ),
        },
        STEP3: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post your Amazon review",
            description2: "Well done! We expect 3 real photos of your purchased product along with the Verified Purchase label.",
            icon3: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title3: "Turn in this assignment",
            description3: "Great! Now it’s time to turn in this assignment — we’ll be monitoring your review on Amazon.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "Great! Now it’s time to Turn In this Assignment — please do it now",
            full_subtitle3: "We will track your review on Amazon.",

            full_description3: (
                <p>
                    After posting your review on Amazon, submit this assignment. From this point, you have reported that you posted your review and may proceed to the next one, while we will be monitoring the appearance of your review on Amazon. <br />
                    This step is mandatory and must be done immediately after posting your review on Amazon site. <br />
                    Our team will then monitor the appearance of your review on Amazon for up to 14+ days.
                </p>
            ),

            full_title4: "Verification in progress",
            full_subtitle4: "We’ll review your files and confirm order details.",
            full_description4: (
                <p>
                    Our team will check your review on Amazon and validate the purchase details from your
                    uploaded files.
                    If anything is missing or unclear, we’ll ask you to re-upload or provide additional
                    information.
                    Once approved, we’ll credit your <b>Virt</b> and reimburse the <b>product’s retail price
                    (excluding delivery)</b>.
                </p>
            ),
        },
        STEP4: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post your Amazon review",
            description2: "Well done! We expect 3 real photos of your purchased product along with the Verified Purchase label.",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "You reported about review successfully posted! Now we must wait a little bit for approval.",

            icon4: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title4: "Awaiting Staff Confirmation",
            description4: "Waiting for your review to appear. Once verified, you will receive Virt reward and reimbursement.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "",
            full_subtitle3: "",
            full_description3: "",

            full_title4: "Verification in progress",
            full_subtitle4: "We’re checking your review and proof of purchase.",
            full_description4: (
                <p>
                    Our team is validating your Amazon review and confirming that the <b>Verified
                    Purchase</b> label is present.
                    We’re also reviewing the uploaded screenshot/photo of your Amazon order to ensure it
                    includes the required details:
                    Order ID, product title or ASIN, order date, product price, and your Amazon account name.{" "}
                    We’ll also check that your review includes at least 3 real photos of the product.{" "}
                    Once verified, your <b>Virt</b> and reimbursement (excluding delivery costs) will be
                    credited.
                    If anything is missing, we’ll contact you for clarification or re-upload.
                </p>
            ),
            verified_purchase: "Verified Purchase",
            photo: "Photos required" || "Not found",
            review_name: book?.selectedCurrentUserAssign?.reviewer_name || "Not found",
            review_site: user?.user?.amz_country || "Amazon",
        },
        STEP5: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post your Amazon review",
            description2: "Well done! We expect 3 real photos of your purchased product along with the Verified Purchase label.",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "You reported about review successfully posted! Now we must wait a little bit for approval.",

            icon4: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Assignment confirmed!",
            description4: "Congratulations! Your review and purchase have been verified. Virt + reimbursement credited.",

            // ===== Expanded step panels =====
            full_title5: `Great! This assignment is fully confirmed!  ${
                book.selectedCurrentUserAssign?.assignment_price_reader ?? 0
            } ${
                book.selectedCurrentUserAssign?.received_bonus
                    ? ` + ${book.selectedCurrentUserAssign.received_bonus} Virt`
                    : ' Virt'
            } and +$${book.selectedCurrentUserAssign?.book_cost_compensation ?? 0} rebate have been credited.`,
            full_subtitle5: "Your Virt and reimbursement have been successfully credited.",
            full_description5: (
                <>
                    <p className="mb-1">
                        This Physical Product Verified Purchase assignment is now closed. You have received
                        your <b>Virt</b> and reimbursement of the <b>product’s retail price (excluding delivery)</b>.
                    </p>
                    <p className="mb-1">
                        Please note that if any discrepancies are found later in verification,
                        adjustments to your balance may still be applied.
                    </p>
                    <p>
                        <b> Thank you for completing this assignment!</b>
                    </p>
                </>
            ),

            verified_purchase: "Verified Purchase",
            photo: "Photos required" || "Not found",
            review_name: book?.selectedCurrentUserAssign?.reviewer_name || "Not found",
            review_site: user?.user?.amz_country || "Amazon",
        },
    },
    8: {
        STEP1: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title1: "Buy the Physical Product",
            description1: "Use the link below to purchase the product. Then click the 'Next Step' button.",

            icon2: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Post review with 3+ photos",
            description2: "Wait for delivery, use the product, and then post review including at least 3 real photos.",


            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: `Purchase the Physical Product directly on Amazon. A rebate of +$${book.selectedCurrentUserAssign?.book_cost_compensation || 'NO'} will be applied once you finish`,
            full_subtitle1: "Verified Purchase and Amazon review with 3+ your own photos required. Proof of purchase is not required, but the review publication date must be later than the assignment start date. Any date mismatch may lead to account suspension.",

            full_description1: (<>
                <p className="mb-1">
                    Please purchase the <b>exact Physical Product ASIN</b> listed for this assignment using your Amazon account.
                    Do <b>not</b> buy used copies or from third-party sellers. Once delivered, use the product carefully and
                    prepare your review.                 </p>
                <p className="mb-1">Your review must show the <b>Verified Purchase</b> label and include <b>at least 3 real photos of the physical product</b>.</p>
                <p> Reimbursement covers the product’s retail price <b>excluding delivery costs</b>. Use the button below to open the Amazon page and complete your purchase.</p>
            </>),

            full_title2: "Use the product and then post your Amazon review with 3+ photos of your purchased copy",
            full_subtitle2: "Your review must display the Verified Purchase label and include real photos.",
            full_description2: (<>
                <p className="mb-1">
                    After receiving the product, write a detailed and honest review. Upload at least <b>3 original photos of the physical product</b> taken with your device. The review must be authentic, accurate, and respectful. AI-generated, plagiarized, or generic reviews
                    are not accepted.
                </p>
                <p>
                    Make sure to post from the same Amazon account you used to purchase the product so the review shows the <b> Verified Purchase</b> label.
                </p>
            </>),

            full_title3: "After Posting your Review on Amazon, Turn In this Assignment",
            full_subtitle3: "We will track your review on Amazon.",

            full_description3: (
                <p>
                    After posting your review on Amazon, submit this assignment. From this point, you have reported that you posted your review and may proceed to the next one, while we will be monitoring the appearance of your review on Amazon. <br />
                    This step is mandatory and must be done immediately after posting your review on Amazon site. <br />
                    Our team will then monitor the appearance of your review on Amazon for up to 14+ days.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the Physical Product Verified Purchase + Photos assignment!
                </p>
            ),
        },
        STEP2: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title2: "Post review with 3+ photos",
            description2: "Wait for delivery, use the product, and then post review including at least 3 real photos.",

            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",
            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "Use the product and then post your Amazon review with 3+ photos of your purchased copy",
            full_subtitle2: "Your review must display the Verified Purchase label and include real photos.",
            full_description2: (<>
                <p className="mb-1">
                    After receiving the product, write a detailed and honest review. Upload at least <b>3 original photos of the physical product</b> taken with your device. The review must be authentic, accurate, and respectful. AI-generated, plagiarized, or generic reviews
                    are not accepted.
                </p>
                <p>
                    Make sure to post from the same Amazon account you used to purchase the product so the review shows the <b> Verified Purchase</b> label.
                </p>
            </>),

            full_title3: "After Posting your Review on Amazon, Turn In this Assignment",
            full_subtitle3: "We will track your review on Amazon.",

            full_description3: (
                <p>
                    After posting your review on Amazon, submit this assignment. From this point, you have reported that you posted your review and may proceed to the next one, while we will be monitoring the appearance of your review on Amazon. <br />
                    This step is mandatory and must be done immediately after posting your review on Amazon site. <br />
                    Our team will then monitor the appearance of your review on Amazon for up to 14+ days.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    After verifying your Amazon review and order proof, we will credit your <b>Virt</b> and reimburse the
                    <b>product’s retail price (excluding delivery)</b> according to the assignment terms.
                    Thank you for completing the Physical Product Verified Purchase + Photos assignment!
                </p>
            ),
        },
        STEP3: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post your Amazon review",
            description2: "Well done! We expect 3 real photos of your purchased product along with the Verified Purchase label.",
            icon3: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title3: "Turn in this assignment",
            description3: "Great! Now it’s time to turn in this assignment — we’ll be monitoring your review on Amazon.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "Great! Now it’s time to Turn In this Assignment — please do it now",
            full_subtitle3: "We will track your review on Amazon.",

            full_description3: (
                <p>
                    After posting your review on Amazon, submit this assignment. From this point, you have reported that you posted your review and may proceed to the next one, while we will be monitoring the appearance of your review on Amazon. <br />
                    This step is mandatory and must be done immediately after posting your review on Amazon site. <br />
                    Our team will then monitor the appearance of your review on Amazon for up to 14+ days.
                </p>
            ),

            full_title4: "Verification in progress",
            full_subtitle4: "We’ll review your files and confirm order details.",
            full_description4: (
                <p>
                    Our team will check your review on Amazon and validate the purchase details from your
                    uploaded files.
                    If anything is missing or unclear, we’ll ask you to re-upload or provide additional
                    information.
                    Once approved, we’ll credit your <b>Virt</b> and reimburse the <b>product’s retail price
                    (excluding delivery)</b>.
                </p>
            ),
        },
        STEP4: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post your Amazon review",
            description2: "Well done! We expect 3 real photos of your purchased product along with the Verified Purchase label.",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "You reported about review successfully posted! Now we must wait a little bit for approval.",

            icon4: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title4: "Awaiting Staff Confirmation",
            description4: "Waiting for your review to appear. Once verified, you will receive Virt reward and reimbursement.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "",
            full_subtitle3: "",
            full_description3: "",

            full_title4: "Verification in progress",
            full_subtitle4: "We’re checking your review and proof of purchase.",
            full_description4: (
                <p>
                    Our team is validating your Amazon review and confirming that the <b>Verified
                    Purchase</b> label is present.
                    We’re also reviewing the uploaded screenshot/photo of your Amazon order to ensure it
                    includes the required details:
                    Order ID, product title or ASIN, order date, product price, and your Amazon account name.{" "}
                    We’ll also check that your review includes at least 3 real photos of the product.{" "}
                    Once verified, your <b>Virt</b> and reimbursement (excluding delivery costs) will be
                    credited.
                    If anything is missing, we’ll contact you for clarification or re-upload.
                </p>
            ),
            verified_purchase: "Verified Purchase",
            photo: "Photos required" || "Not found",
            review_name: book?.selectedCurrentUserAssign?.reviewer_name || "Not found",
            review_site: user?.user?.amz_country || "Amazon",
        },
        STEP5: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post your Amazon review",
            description2: "Well done! We expect 3 real photos of your purchased product along with the Verified Purchase label.",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "You reported about review successfully posted! Now we must wait a little bit for approval.",

            icon4: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Assignment confirmed!",
            description4: "Congratulations! Your review and purchase have been verified. Virt + reimbursement credited.",

            // ===== Expanded step panels =====
            full_title5: `Great! This assignment is fully confirmed!  ${
                book.selectedCurrentUserAssign?.assignment_price_reader ?? 0
            } ${
                book.selectedCurrentUserAssign?.received_bonus
                    ? ` + ${book.selectedCurrentUserAssign.received_bonus} Virt`
                    : ' Virt'
            } and +$${book.selectedCurrentUserAssign?.book_cost_compensation ?? 0} rebate have been credited.`,
            full_subtitle5: "Your Virt and reimbursement have been successfully credited.",
            full_description5: (
                <>
                    <p className="mb-1">
                        This Physical Product Verified Purchase assignment is now closed. You have received
                        your <b>Virt</b> and reimbursement of the <b>product’s retail price (excluding delivery)</b>.
                    </p>
                    <p className="mb-1">
                        Please note that if any discrepancies are found later in verification,
                        adjustments to your balance may still be applied.
                    </p>
                    <p>
                        <b> Thank you for completing this assignment!</b>
                    </p>
                </>
            ),

            verified_purchase: "Verified Purchase",
            photo: "Photos required" || "Not found",
            review_name: book?.selectedCurrentUserAssign?.reviewer_name || "Not found",
            review_site: user?.user?.amz_country || "Amazon",
        },
    },
    9: {
        STEP1: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title1: "Buy the Physical Product",
            description1: "Use the link below to purchase the product. Then click the 'Next Step' button.",

            icon2: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Post review with 3+ photos",
            description2: "Wait for delivery, use the product, and then post review including at least 3 real photos.",


            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: `Purchase the Physical Product directly on Amazon. A rebate of +$${book.selectedCurrentUserAssign?.book_cost_compensation || 'NO'} will be applied once you finish`,
            full_subtitle1: "Verified Purchase and Amazon review with 3+ your own photos required. Proof of purchase is not required, but the review publication date must be later than the assignment start date. Any date mismatch may lead to account suspension.",

            full_description1: (<>
                <p className="mb-1">
                    Please purchase the <b>exact Physical Product ASIN</b> listed for this assignment using your Amazon account.
                    Do <b>not</b> buy used copies or from third-party sellers. Once delivered, use the product carefully and
                    prepare your review.                 </p>
                <p className="mb-1">Your review must show the <b>Verified Purchase</b> label and include <b>at least 3 real photos of the physical product</b>.</p>
                <p> Reimbursement covers the product’s retail price <b>excluding delivery costs</b>. Use the button below to open the Amazon page and complete your purchase.</p>
            </>),

            full_title2: "Use the product and then post your Amazon review with 3+ photos of your purchased copy",
            full_subtitle2: "Your review must display the Verified Purchase label and include real photos.",
            full_description2: (<>
                <p className="mb-1">
                    After receiving the product, write a detailed and honest review. Upload at least <b>3 original photos of the physical product</b> taken with your device. The review must be authentic, accurate, and respectful. AI-generated, plagiarized, or generic reviews
                    are not accepted.
                </p>
                <p>
                    Make sure to post from the same Amazon account you used to purchase the product so the review shows the <b> Verified Purchase</b> label.
                </p>
            </>),

            full_title3: "After Posting your Review on Amazon, Turn In this Assignment",
            full_subtitle3: "We will track your review on Amazon.",

            full_description3: (
                <p>
                    After posting your review on Amazon, submit this assignment. From this point, you have reported that you posted your review and may proceed to the next one, while we will be monitoring the appearance of your review on Amazon. <br />
                    This step is mandatory and must be done immediately after posting your review on Amazon site. <br />
                    Our team will then monitor the appearance of your review on Amazon for up to 14+ days.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the Physical Product Verified Purchase + Photos assignment!
                </p>
            ),
        },
        STEP2: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title2: "Post review with 3+ photos",
            description2: "Wait for delivery, use the product, and then post review including at least 3 real photos.",

            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",
            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "Use the product and then post your Amazon review with 3+ photos of your purchased copy",
            full_subtitle2: "Your review must display the Verified Purchase label and include real photos.",
            full_description2: (<>
                <p className="mb-1">
                    After receiving the product, write a detailed and honest review. Upload at least <b>3 original photos of the physical product</b> taken with your device. The review must be authentic, accurate, and respectful. AI-generated, plagiarized, or generic reviews
                    are not accepted.
                </p>
                <p>
                    Make sure to post from the same Amazon account you used to purchase the product so the review shows the <b> Verified Purchase</b> label.
                </p>
            </>),

            full_title3: "After Posting your Review on Amazon, Turn In this Assignment",
            full_subtitle3: "We will track your review on Amazon.",

            full_description3: (
                <p>
                    After posting your review on Amazon, submit this assignment. From this point, you have reported that you posted your review and may proceed to the next one, while we will be monitoring the appearance of your review on Amazon. <br />
                    This step is mandatory and must be done immediately after posting your review on Amazon site. <br />
                    Our team will then monitor the appearance of your review on Amazon for up to 14+ days.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    After verifying your Amazon review and order proof, we will credit your <b>Virt</b> and reimburse the
                    <b>product’s retail price (excluding delivery)</b> according to the assignment terms.
                    Thank you for completing the Physical Product Verified Purchase + Photos assignment!
                </p>
            ),
        },
        STEP3: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post your Amazon review",
            description2: "Well done! We expect 3 real photos of your purchased product along with the Verified Purchase label.",
            icon3: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title3: "Turn in this assignment",
            description3: "Great! Now it’s time to turn in this assignment — we’ll be monitoring your review on Amazon.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "Great! Now it’s time to Turn In this Assignment — please do it now",
            full_subtitle3: "We will track your review on Amazon.",

            full_description3: (
                <p>
                    After posting your review on Amazon, submit this assignment. From this point, you have reported that you posted your review and may proceed to the next one, while we will be monitoring the appearance of your review on Amazon. <br />
                    This step is mandatory and must be done immediately after posting your review on Amazon site. <br />
                    Our team will then monitor the appearance of your review on Amazon for up to 14+ days.
                </p>
            ),

            full_title4: "Verification in progress",
            full_subtitle4: "We’ll review your files and confirm order details.",
            full_description4: (
                <p>
                    Our team will check your review on Amazon and validate the purchase details from your
                    uploaded files.
                    If anything is missing or unclear, we’ll ask you to re-upload or provide additional
                    information.
                    Once approved, we’ll credit your <b>Virt</b> and reimburse the <b>product’s retail price
                    (excluding delivery)</b>.
                </p>
            ),
        },
        STEP4: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post your Amazon review",
            description2: "Well done! We expect 3 real photos of your purchased product along with the Verified Purchase label.",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "You reported about review successfully posted! Now we must wait a little bit for approval.",

            icon4: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title4: "Awaiting Staff Confirmation",
            description4: "Waiting for your review to appear. Once verified, you will receive Virt reward and reimbursement.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "",
            full_subtitle3: "",
            full_description3: "",

            full_title4: "Verification in progress",
            full_subtitle4: "We’re checking your review and proof of purchase.",
            full_description4: (
                <p>
                    Our team is validating your Amazon review and confirming that the <b>Verified
                    Purchase</b> label is present.
                    We’re also reviewing the uploaded screenshot/photo of your Amazon order to ensure it
                    includes the required details:
                    Order ID, product title or ASIN, order date, product price, and your Amazon account name.{" "}
                    We’ll also check that your review includes at least 3 real photos of the product.{" "}
                    Once verified, your <b>Virt</b> and reimbursement (excluding delivery costs) will be
                    credited.
                    If anything is missing, we’ll contact you for clarification or re-upload.
                </p>
            ),
            verified_purchase: "Verified Purchase",
            photo: "Photos required" || "Not found",
            review_name: book?.selectedCurrentUserAssign?.reviewer_name || "Not found",
            review_site: user?.user?.amz_country || "Amazon",
        },
        STEP5: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post your Amazon review",
            description2: "Well done! We expect 3 real photos of your purchased product along with the Verified Purchase label.",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "You reported about review successfully posted! Now we must wait a little bit for approval.",

            icon4: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Assignment confirmed!",
            description4: "Congratulations! Your review and purchase have been verified. Virt + reimbursement credited.",

            // ===== Expanded step panels =====
            full_title5: `Great! This assignment is fully confirmed!  ${
                book.selectedCurrentUserAssign?.assignment_price_reader ?? 0
            } ${
                book.selectedCurrentUserAssign?.received_bonus
                    ? ` + ${book.selectedCurrentUserAssign.received_bonus} Virt`
                    : ' Virt'
            } and +$${book.selectedCurrentUserAssign?.book_cost_compensation ?? 0} rebate have been credited.`,
            full_subtitle5: "Your Virt and reimbursement have been successfully credited.",
            full_description5: (
                <>
                    <p className="mb-1">
                        This Physical Product Verified Purchase assignment is now closed. You have received
                        your <b>Virt</b> and reimbursement of the <b>product’s retail price (excluding delivery)</b>.
                    </p>
                    <p className="mb-1">
                        Please note that if any discrepancies are found later in verification,
                        adjustments to your balance may still be applied.
                    </p>
                    <p>
                        <b> Thank you for completing this assignment!</b>
                    </p>
                </>
            ),

            verified_purchase: "Verified Purchase",
            photo: "Photos required" || "Not found",
            review_name: book?.selectedCurrentUserAssign?.reviewer_name || "Not found",
            review_site: user?.user?.amz_country || "Amazon",
        },
    },
    10: {
        STEP1: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title1: "Buy the Physical Product",
            description1: "Use the link below to purchase the product. Then click the 'Next Step' button.",

            icon2: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Post review with 3+ photos",
            description2: "Wait for delivery, use the product, and then post review including at least 3 real photos.",


            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: `Purchase the Physical Product directly on Amazon. A rebate of +$${book.selectedCurrentUserAssign?.book_cost_compensation || 'NO'} will be applied once you finish`,
            full_subtitle1: "Verified Purchase and Amazon review with 3+ your own photos required. Proof of purchase is not required, but the review publication date must be later than the assignment start date. Any date mismatch may lead to account suspension.",

            full_description1: (<>
                <p className="mb-1">
                    Please purchase the <b>exact Physical Product ASIN</b> listed for this assignment using your Amazon account.
                    Do <b>not</b> buy used copies or from third-party sellers. Once delivered, use the product carefully and
                    prepare your review.                 </p>
                <p className="mb-1">Your review must show the <b>Verified Purchase</b> label and include <b>at least 3 real photos of the physical product</b>.</p>
                <p> Reimbursement covers the product’s retail price <b>excluding delivery costs</b>. Use the button below to open the Amazon page and complete your purchase.</p>
            </>),

            full_title2: "Use the product and then post your Amazon review with 3+ photos of your purchased copy",
            full_subtitle2: "Your review must display the Verified Purchase label and include real photos.",
            full_description2: (<>
                <p className="mb-1">
                    After receiving the product, write a detailed and honest review. Upload at least <b>3 original photos of the physical product</b> taken with your device. The review must be authentic, accurate, and respectful. AI-generated, plagiarized, or generic reviews
                    are not accepted.
                </p>
                <p>
                    Make sure to post from the same Amazon account you used to purchase the product so the review shows the <b> Verified Purchase</b> label.
                </p>
            </>),

            full_title3: "After Posting your Review on Amazon, Turn In this Assignment",
            full_subtitle3: "We will track your review on Amazon.",

            full_description3: (
                <p>
                    After posting your review on Amazon, submit this assignment. From this point, you have reported that you posted your review and may proceed to the next one, while we will be monitoring the appearance of your review on Amazon. <br />
                    This step is mandatory and must be done immediately after posting your review on Amazon site. <br />
                    Our team will then monitor the appearance of your review on Amazon for up to 14+ days.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the Physical Product Verified Purchase + Photos assignment!
                </p>
            ),
        },
        STEP2: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title2: "Post review with 3+ photos",
            description2: "Wait for delivery, use the product, and then post review including at least 3 real photos.",

            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",
            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "Use the product and then post your Amazon review with 3+ photos of your purchased copy",
            full_subtitle2: "Your review must display the Verified Purchase label and include real photos.",
            full_description2: (<>
                <p className="mb-1">
                    After receiving the product, write a detailed and honest review. Upload at least <b>3 original photos of the physical product</b> taken with your device. The review must be authentic, accurate, and respectful. AI-generated, plagiarized, or generic reviews
                    are not accepted.
                </p>
                <p>
                    Make sure to post from the same Amazon account you used to purchase the product so the review shows the <b> Verified Purchase</b> label.
                </p>
            </>),

            full_title3: "After Posting your Review on Amazon, Turn In this Assignment",
            full_subtitle3: "We will track your review on Amazon.",

            full_description3: (
                <p>
                    After posting your review on Amazon, submit this assignment. From this point, you have reported that you posted your review and may proceed to the next one, while we will be monitoring the appearance of your review on Amazon. <br />
                    This step is mandatory and must be done immediately after posting your review on Amazon site. <br />
                    Our team will then monitor the appearance of your review on Amazon for up to 14+ days.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    After verifying your Amazon review and order proof, we will credit your <b>Virt</b> and reimburse the
                    <b>product’s retail price (excluding delivery)</b> according to the assignment terms.
                    Thank you for completing the Physical Product Verified Purchase + Photos assignment!
                </p>
            ),
        },
        STEP3: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post your Amazon review",
            description2: "Well done! We expect 3 real photos of your purchased product along with the Verified Purchase label.",
            icon3: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title3: "Turn in this assignment",
            description3: "Great! Now it’s time to turn in this assignment — we’ll be monitoring your review on Amazon.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "Great! Now it’s time to Turn In this Assignment — please do it now",
            full_subtitle3: "We will track your review on Amazon.",

            full_description3: (
                <p>
                    After posting your review on Amazon, submit this assignment. From this point, you have reported that you posted your review and may proceed to the next one, while we will be monitoring the appearance of your review on Amazon. <br />
                    This step is mandatory and must be done immediately after posting your review on Amazon site. <br />
                    Our team will then monitor the appearance of your review on Amazon for up to 14+ days.
                </p>
            ),

            full_title4: "Verification in progress",
            full_subtitle4: "We’ll review your files and confirm order details.",
            full_description4: (
                <p>
                    Our team will check your review on Amazon and validate the purchase details from your
                    uploaded files.
                    If anything is missing or unclear, we’ll ask you to re-upload or provide additional
                    information.
                    Once approved, we’ll credit your <b>Virt</b> and reimburse the <b>product’s retail price
                    (excluding delivery)</b>.
                </p>
            ),
        },
        STEP4: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post your Amazon review",
            description2: "Well done! We expect 3 real photos of your purchased product along with the Verified Purchase label.",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "You reported about review successfully posted! Now we must wait a little bit for approval.",

            icon4: <FaHourglassHalf
                className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite"
                size={15}/>,
            title4: "Awaiting Staff Confirmation",
            description4: "Waiting for your review to appear. Once verified, you will receive Virt reward and reimbursement.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "",
            full_subtitle3: "",
            full_description3: "",

            full_title4: "Verification in progress",
            full_subtitle4: "We’re checking your review and proof of purchase.",
            full_description4: (
                <p>
                    Our team is validating your Amazon review and confirming that the <b>Verified
                    Purchase</b> label is present.
                    We’re also reviewing the uploaded screenshot/photo of your Amazon order to ensure it
                    includes the required details:
                    Order ID, product title or ASIN, order date, product price, and your Amazon account name.{" "}
                    We’ll also check that your review includes at least 3 real photos of the product.{" "}
                    Once verified, your <b>Virt</b> and reimbursement (excluding delivery costs) will be
                    credited.
                    If anything is missing, we’ll contact you for clarification or re-upload.
                </p>
            ),
            verified_purchase: "Verified Purchase",
            photo: "Photos required" || "Not found",
            review_name: book?.selectedCurrentUserAssign?.reviewer_name || "Not found",
            review_site: user?.user?.amz_country || "Amazon",
        },
        STEP5: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title1: "Buy the Physical Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title2: "Post your Amazon review",
            description2: "Well done! We expect 3 real photos of your purchased product along with the Verified Purchase label.",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title3: "Turn in this assignment",
            description3: "You reported about review successfully posted! Now we must wait a little bit for approval.",

            icon4: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Assignment confirmed!",
            description4: "Congratulations! Your review and purchase have been verified. Virt + reimbursement credited.",

            // ===== Expanded step panels =====
            full_title5: `Great! This assignment is fully confirmed!  ${
                book.selectedCurrentUserAssign?.assignment_price_reader ?? 0
            } ${
                book.selectedCurrentUserAssign?.received_bonus
                    ? ` + ${book.selectedCurrentUserAssign.received_bonus} Virt`
                    : ' Virt'
            } and +$${book.selectedCurrentUserAssign?.book_cost_compensation ?? 0} rebate have been credited.`,
            full_subtitle5: "Your Virt and reimbursement have been successfully credited.",
            full_description5: (
                <>
                    <p className="mb-1">
                        This Physical Product Verified Purchase assignment is now closed. You have received
                        your <b>Virt</b> and reimbursement of the <b>product’s retail price (excluding delivery)</b>.
                    </p>
                    <p className="mb-1">
                        Please note that if any discrepancies are found later in verification,
                        adjustments to your balance may still be applied.
                    </p>
                    <p>
                        <b> Thank you for completing this assignment!</b>
                    </p>
                </>
            ),

            verified_purchase: "Verified Purchase",
            photo: "Photos required" || "Not found",
            review_name: book?.selectedCurrentUserAssign?.reviewer_name || "Not found",
            review_site: user?.user?.amz_country || "Amazon",
        },
    },
});
